import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/CustomNavbar';
import DarkModeToggle from './components/DarkModeToggle';
import Home from './components/Home';
import Projects from './components/Projects';
import Footer from './components/Footer';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Education from './components/Education';
import Experience from './components/Experience';
import Achievements from './components/Achievements';
import Games from './components/Games';
import ErrorPage from './components/ErrorPage';
import Login from './components/Login';
import Copyright from './components/Copyright';
import ProtectedRoute from './components/ProtectedRoute';
import Messages from './components/Messages';
import Analytics from './components/Analytics';
import VisitTracker from './components/VisitTracker';
import ToastHost from './components/ToastHost';
import { ADMIN_AUTH_EVENT } from './actions/authEvents';
import './stylesheet/mode.scss';
import './stylesheet/BackgroundAnimation.scss'
import './stylesheet/Glass.css';

class App extends Component {
  constructor(props) {
      super(props);
      this.state = { isLoggedIn: false };
  }

  componentDidMount() {
      this.syncLoginState();
      // Same fix as CustomNavbar: App is mounted once at the top, so a
      // same-tab login on /admin needs this event to be noticed instead of
      // requiring a full refresh before /message or /analytics unlock.
      window.addEventListener(ADMIN_AUTH_EVENT, this.syncLoginState);
  }

  componentWillUnmount() {
      window.removeEventListener(ADMIN_AUTH_EVENT, this.syncLoginState);
  }

  syncLoginState = () => {
      this.setState({ isLoggedIn: localStorage.getItem('adminLoggedIn') });
  }

  render() {
    return (
      <Router>
        <div className="animContainer">
          <ul className="animParticles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
          </ul>
        </div>
        <div className="appContainer">
          <Navbar />
          <DarkModeToggle />
          <ToastHost />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/education" element={<Education />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/games" element={<Games />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Login />} />
            <Route path="/message" element={<ProtectedRoute isAuthenticated={this.state.isLoggedIn}><Messages /></ProtectedRoute>}/>
            <Route path="/analytics" element={<ProtectedRoute isAuthenticated={this.state.isLoggedIn}><Analytics /></ProtectedRoute>}/>
            <Route path="/*" element={<ErrorPage />} />
          </Routes>
          <VisitTracker />
          <Footer />
          <Copyright />
        </div>
      </Router>
    );
  }
}

export default App;
